  <template>
    <div class="client-listing-detail fluid mt-5">
      <div class="container" style="padding: 0px 50px;">
        <div v-if="errors.length" class="d-flex justify-content-center">
          <p v-for="(error, idx) in errors" class="text-danger" :key="idx">{{ error }}</p>
        </div>
        <div class="col-sm-4 text-center mb-2 ms-5" style="height: 30px;">
          <button class="btn select-all-btn" v-if="isCheckedApplicants()" @click="setApplicantJds">
            ユーザーにJDを選択
          </button>
        </div>
        <div class="jd-description-panel" v-if="isJdVisible" :class="{ show: isJdVisible }">
          <JobDescription :job="currentJd" @toggle="toggleJdDescription" :isJDList="isJdVisible" :isMaxHeight="true"/>
        </div>
        <Loader v-if="loading" />
        <div class="client-listing-detail position-relative" v-else>
          <table class="table">
            <thead>
              <tr>
                <th style="width: 20px !important;">
                  <input
                    type="checkbox"
                    v-model="isCheckAll"
                    @click="checkAll()"
                    style="width: 18px; height: 18px; margin-left: 5px;"
                  />
                </th>
                <th style="width: 30px !important;"></th>
                <th style="width: 500px;">職務経歴書 or 職務要約</th>
                <th>登録/更新日</th>
                <th>年齢</th>
                <th>卒業学校名</th>
                <th>在籍企業</th>
                <th style="width: 160px;">経験職種</th>
                <th>年収</th>
                <th>メモ</th>
                <th style="width: 140px;">対象ステータス</th>
              </tr>
            </thead>
            <tbody>
              <div class="btn-toggle-jd" v-if="!isJdVisible" @click="toggleJdDescription">
                {{ isJdVisible ? 'JD詳細を開閉' : 'JD詳細を開閉' }}
              </div>
              <JDMatchingRow
                v-for="(jobseeker, index) in filteredJobseekers"
                :key="jobseeker.id"
                :index="index"
                :jobseeker="jobseeker"
                :isChecked="isCheckedJobseeker(jobseeker.id)"
                @changed="checkUncheckJobseeker"
              />
            </tbody>
          </table>
          <div class="col-sm-4 text-center mb-2 ms-5">
            <button class="btn select-all-btn" v-if="isCheckedApplicants()" @click="setApplicantJds">
              ユーザーにJDを選択
            </button>
          </div>
          <p v-if="errorMessage" v-html="errorMessage" style="text-align: center;"></p>
          <b-modal
            ref="jdModal"
            id="confirm-modal"
            hide-header
            hide-footer
            size="md"
            no-close-on-backdrop
            no-close-on-esc
            centered
          >
            <div class="text-center">
              <!-- Exclamation Icon -->
              <div class="swal-icon swal-icon--warning">
                      <span class="swal-icon--warning__body">
                          <span class="swal-icon--warning__dot"></span>
                      </span>
                  </div>

              <!-- Confirmation Text -->
              <div class="confirmation-text mb-4">
                <p class="font-weight-bold">以下のJDをユーザーに設定しますか</p>
              </div>

              <!-- Description -->
              <div class="description-text mb-4">
                <p>
                  {{ currentJd.job_title }}
                </p>
              </div>

              <!-- Buttons -->
              <div class="button-group">
                <button class="me-3 btn-secondary jd-btn" @click="hideModal">
                  ユーザー選択に戻る
                </button>
                <button class="btn btn-danger jd-btn" @click.prevent="confirmSelection">
                  設定する
                </button>
              </div>
            </div>
          </b-modal>
        </div>
      </div>
    </div>
  </template>

  <script>
  import JDMatchingRow from './JDMatchingRow.vue';
  import JobDescription from './JobDescription.vue';
  import apiService from '../../../service/apiService';
  import api from '../../../config/api';
  import Loader from '../../utils/Loader.vue';
  import mutations from '@/config/mutations';
  import { mapMutations, mapActions } from 'vuex';
  import moment from 'moment';
  export default {
    name: 'JDMatchingList',
    components: {
      Loader,
      JDMatchingRow,
      JobDescription,
    },
    data() {
      return {
        jobSeekers: [],
        jobseekerIds: [],
        currentJd: null,
        loading: false,
        isSubmitting: false,
        isJdVisible: false,
        isCheckAll: false,
        isModalVisible: false,
        errors: [],
        errorMessage: '',
      };
    },
    computed: {
      filteredJobseekers() {
        return this.jobSeekers.slice(0,50);
      }
    },
    methods: {
      ...mapMutations({
        setApplicantsCount: 'setApplicantCounts',
        setApplicants: mutations.applicant.SET_APPLICANTS,
      }),
      ...mapActions({
        multipleJobseekerSelection: 'multipleJobseekerSelection',
      }),
      async confirmSelection() {
        try {
          this.loading = true;
          this.errors = [];
          const data = {
            eligibility: true,
            jobseekers: this.jobseekerIds,
            // matching_score: 0,
          };
          data.timestamp = moment().format('YYYY-MM-DD HH:mm');
          await this.multipleJobseekerSelection({
            jd: this.currentJd,
            jobseekerIds: this.jobseekerIds,
            data,
          });
          this.jobseekerIds = [];
          this.isCheckAll = false;
          // this.hideModal();
        } catch (err) {
          console.log(err.response);
          this.parseErrorResponse(err.response);
          this.loading = false;
        } finally {
          this.loading = false;
        }
      },
      setApplicantJds() {
        this.$refs.jdModal.show();
      },
      hideModal() {
        this.$refs.jdModal.hide();
      },
      toggleJdDescription() {
        this.isJdVisible = !this.isJdVisible;
      },
      checkAll() {
        this.isCheckAll = !this.isCheckAll;
        this.jobseekerIds = [];
        if (this.isCheckAll) {
          for (var key in this.jobSeekers) {
            this.jobseekerIds.push(this.jobSeekers[key].id);
          }
        }
      },
      isCheckedJobseeker(id) {
        return this.jobseekerIds.includes(id);
      },
      isCheckedApplicants() {
        return this.jobseekerIds.length ? true : false;
      },
      checkUncheckJobseeker(id) {
        const index = this.jobseekerIds.indexOf(id);
        if (index > -1) {
          this.jobseekerIds.splice(index, 1);
        } else {
          this.jobseekerIds.push(id);
        }
      },
      async getJD(id) {
        this.loading = true;
        try {
          const jd = await apiService.get(api.endpoints.JD_BY_ID(id));
          this.currentJd = jd.data.data;
          this.loading = false;
        } catch (err) {
          this.parseErrorResponse(err.response);
          this.loading = false;
        }
      },
      async getMatchingJobseekerList(id, filters = {}) {
        this.loading = true;
        try {
          const queryParams = {
            created_date: filters.created_date || '',
            age_from: filters.age_from || '',
            age_to: filters.age_to || '',
            last_year_income_from: filters.last_year_income_from || '',
            last_year_income_to: filters.last_year_income_to || '',
            status: filters.status || '',
            english_skills: filters.english_skills || [],
            latest_occupation_sub_title: filters.latest_occupation_sub_title || [],
            latest_occupation_main_title: filters.latest_occupation_main_title || [],
          };
          const matchingList = await apiService.get(api.endpoints.JD_MATCHING_LIST(id), {}, queryParams);

          this.jobSeekers = matchingList.data.data.matchedJobseekers;

          if (this.jobSeekers.length > 0) {
            this.setApplicants(this.jobSeekers);
            this.setApplicantsCount({
              total: this.jobSeekers.length,
              from: 1,
              to: this.jobSeekers.length,
              perPage: this.jobSeekers.length,
            });
          }
          this.currentJd = matchingList.data.data.jobDescription;
        } catch (err) {
          // console.log(err.response);
          if (err && err.response && err.response.status === 404) {
            this.errorMessage = '候補者が見つかりませんでした<br/>別の募集Job Descriptionのマッチングへお進みください';
          } else {
            this.errorMessage =
              '何らかのエラーが発生しています<br/>時間を置いても改善されない場合は、Bloom技術チームにお知らせください';
          }
        } finally {
          this.loading = false;
        }
      },
    },
    async created() {
      const id = this.$route.params.id;
      const { status, english_skills, latest_occupation_sub_title, latest_occupation_main_title, created_date, age_from, age_to, last_year_income_from, last_year_income_to } = this.$route.query;

      // Convert comma-separated strings back to arrays
      const filters = {
        created_date,
        age_from,
        age_to,
        last_year_income_from,
        last_year_income_to,
        status: status ? status.split(',') : [],
        english_skills: english_skills ? english_skills.split(',') : [],
        latest_occupation_sub_title: latest_occupation_sub_title ? latest_occupation_sub_title.split(',') : [],
        latest_occupation_main_title: latest_occupation_main_title ? latest_occupation_main_title.split(',') : [],
      };
      await this.getJD(id);
      await this.getMatchingJobseekerList(id, filters);
    },
    mounted() {
      this.changeBodyBackground();
    },
  };
  </script>
  <style scoped>

  .swal-icon {
      width: 60px;
      height: 60px;
      border-width: 4px;
      border-style: solid;
      border-radius: 50%;
      padding: 0;
      position: relative;
      box-sizing: content-box;
      margin: 20px auto;
  }

  .swal-icon--warning {
      border-color: #f8bb86;
      -webkit-animation: pulseWarning .75s infinite alternate;
      animation: pulseWarning .75s infinite alternate;
  }

  .swal-icon--warning__body, .swal-icon--warning__dot {
      position: absolute;
      left: 50%;
      background-color: #f8bb86;
      width: 7px;
      height: 7px;
      border-radius: 50%;
      margin-left: -4px;
      bottom: -11px;
  }

  .swal-icon--warning__body {
      width: 5px;
      height: 33px;
      top: 10px;
      border-radius: 2px;
      margin-left: -2px;
  }

  .jd-btn {
    cursor: pointer;
    color: #fff;
    border-radius: 4px;
    border: none;
    padding: 3px 18px;
    min-width: 170px;
    width: 170px;
    height: 40px;
  }
  .jd-btn :hover {
    opacity: 0.8;
  }
  .jd-submit-btn {
    background: #eb5757;
  }
  .jd-close-btn {
    background: #787878;
  }

  .select-all-btn {
    background: #787878;
    color: #fff;
    border-radius: 4px;
    border: none;
    padding: 3px 18px;
  }

  .table th {
    text-align: center;
  }
  .position-relative {
    position: relative;
  }

  .btn-toggle-jd {
    position: fixed; 
    width: 40px;
    /* left: -45px; */
    margin-left: -45px;
    top: 40%;
    /* position: absolute; */
    transform: translateY(-50%);
    z-index: 100;
    padding: 15px 8px;
    background: white;
    color: #000;
    border: none;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    border-left: 2px solid white;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  .shifted {
    left: 650px;
    /* margin-left: 25px; */
  }
  .jd-description-panel {
    position: fixed; /* Change from absolute to fixed */
    top: 80px; /* Adjust this value based on your header height */
    left: 0;
    height: calc(100vh - 80px); /* Subtract the top offset */
    transition: all 0.3s ease;
    z-index: 90;
    overflow-y: auto;
  }

  .jd-description-panel.show {
    left: 0;
  }

  /* Ensure table container is properly positioned */
  .client-listing-detail {
    position: relative;
    z-index: 80;
  }

  /* Optional: Add transition to table for smooth animation */
  .table {
    transition: all 0.3s ease;
  }
  </style>
